/**
 * account-mobile-lib.ts — Các nhóm dòng của màn "Cài đặt" trên ĐIỆN THOẠI (bám mẫu Cài đặt của Lark Mobile: nhiều thẻ nhóm bo tròn, mỗi
 * dòng một mục + mũi tên). Hàm thuần — có test. Nhãn / đường dẫn lấy từ account-modules.ts nên không lệch với máy tính.
 */
import { i18n } from '@/lib/i18n'
import { ACCOUNT_MODULES_META } from './account-modules'

export interface SettingsRow {
  key: string
  label: string
  to: string
  /** Giá trị hiện tại hiện bên phải (vd chủ đề đang chọn). */
  value?: string
  /** Chỉ dùng trên máy tính — bấm vẫn mở được (màn nhắc + gửi liên kết sang máy tính). */
  pc?: boolean
}

export interface SettingsGroup {
  key: 'account' | 'general' | 'org'
  rows: SettingsRow[]
}

const labelOf = (id: string) => ACCOUNT_MODULES_META.find((m) => m.id === id)?.label ?? id
const row = (id: string, value?: string): SettingsRow => ({ key: id, label: labelOf(id), to: `/account/${id}`, value })

/**
 * Tài khoản (hồ sơ, bảo mật, lịch sử đăng nhập) → Chung (giao diện, thông báo, phím tắt) → Tổ chức (cài đặt hệ thống, chỉ hiện khi vai trò + quyền
 * cho vào — trang đó chỉ dùng trên máy tính nên có nhãn PC).
 */
export function buildSettingsGroups(o: { themeLabel: string; orgSettings: boolean }): SettingsGroup[] {
  const groups: SettingsGroup[] = [
    { key: 'account', rows: [row('profile'), row('login-history')] },
    { key: 'general', rows: [row('preferences', o.themeLabel), row('notifications'), row('shortcuts')] },
  ]
  if (o.orgSettings) {
    groups.push({ key: 'org', rows: [{ key: 'org-settings', label: i18n.t('accountPages:mobile.orgSettings'), to: '/settings', pc: true }] })
  }
  return groups
}
